// Modules
import { isValidCPF } from '@brazilian-utils/brazilian-utils'

export const convertToNumber = (value: string | undefined): string => (value ? value.replace(/[^0-9]/g, '') : '')

export const federalTaxIdValidator = (federalTaxId: string | undefined): boolean => {
    const formatFederalTaxId = convertToNumber(federalTaxId)
    return isValidCPF(formatFederalTaxId)
}
